export default __webpack_public_path__ + "static/media/icon-mongo-db.7a16fc61.png";